import { render } from "./LanguageRouterLink.vue?vue&type=template&id=296e1dff&ts=true"
import script from "./LanguageRouterLink.vue?vue&type=script&lang=ts"
export * from "./LanguageRouterLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__